import { useMemo, useState } from 'react';

type ReturnType<TState> = {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  error: Error | null;
  setError: (error: Error | null) => void;
  data: TState | null;
  setData: (data: TState | null) => void;
};

export function useAsyncCallState<TState>(): ReturnType<TState> {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const [data, setData] = useState<TState | null>(null);

  return useMemo(
    () => ({
      isLoading,
      setIsLoading,
      error,
      setError,
      data,
      setData,
    }),
    [isLoading, error, data],
  );
}
